export default "__VITE_ASSET__1f9a4eef__"